// extracted by mini-css-extract-plugin
export var block = "via-transit-widget-block-module--block--c30cf";
export var blockHeader = "via-transit-widget-block-module--blockHeader--92ecf";
export var fullScreen = "via-transit-widget-block-module--fullScreen--c51f0";
export var title = "via-transit-widget-block-module--title--987da";
export var widgetContainer = "via-transit-widget-block-module--widgetContainer--b8900";